module.exports = __webpack_public_path__ + "img/couponImg.db54f986.png";